// Canonical source file; legacy compiled .js artifacts were removed to avoid module shadowing.
import { useEffect, useState } from "react";

interface BuildInfoProps {
  apiBaseUrl: string;
}

interface VersionResponse {
  version: string;
  commit: string;
}

export default function BuildInfoFooter({ apiBaseUrl }: BuildInfoProps): JSX.Element {
  const [info, setInfo] = useState<VersionResponse>();
  const frontendBuildSha = (import.meta.env.VITE_BUILD_SHA as string | undefined) ?? "";
  const shortFrontendSha = frontendBuildSha ? frontendBuildSha.slice(0, 7) : "";

  useEffect(() => {
    let cancelled = false;

    async function load(): Promise<void> {
      try {
        const response = await fetch(`${apiBaseUrl}/version`, {
          headers: { Accept: "application/json" }
        });
        if (!response.ok) {
          throw new Error(`Unexpected status: ${response.status}`);
        }
        const data = (await response.json()) as VersionResponse;
        if (!cancelled) {
          setInfo(data);
        }
      } catch (error) {
        console.warn("Unable to load build info", error);
      }
    }

    void load();

    return () => {
      cancelled = true;
    };
  }, [apiBaseUrl]);

  return (
    <footer style={{ borderTop: "1px solid #e5e7eb", marginTop: "2rem", paddingTop: "1rem", fontSize: "0.875rem" }}>
      <div>
        {shortFrontendSha ? <span>UI {shortFrontendSha}</span> : <span>UI build: unknown</span>}
      </div>
      <div style={{ color: "#64748b", marginTop: ".25rem" }}>
        {info ? <span>API {info.version} — {info.commit}</span> : <span>Loading API build metadata…</span>}
      </div>
    </footer>
  );
}
